import HTTP from "@/_helpers/http";
import { ACCOUNTTYPES__API } from "@/_helpers/urls";
import { ACCOUNTTYPES__MUTATIONS } from "../mutation-types";
import { ACCOUNTTYPES__ACTIONS } from "../action-types";

// State
const state = {
  accounttypes: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [ACCOUNTTYPES__MUTATIONS.ACCOUNTTYPES](state, data) {
    state.accounttypes = data;
  },
};

// Actions
const actions = {
  async [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]({ commit, state }) {
    try {
      const response = await HTTP().get(ACCOUNTTYPES__API.ACCOUNTTYPES);
      commit(ACCOUNTTYPES__MUTATIONS.ACCOUNTTYPES, response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
